import { z } from 'zod';
import {
  OperatorTypeEnum,
  UserResponsibleTypeEnum,
} from '../dtos/enums/accessAutomation.enum';

export const OperatorTypeEnumZ = z.nativeEnum(OperatorTypeEnum);
export const UserResponsibleTypeEnumZ = z.nativeEnum(UserResponsibleTypeEnum);

const OperatorAccessDetailsSchema = z.object({
  usercode: z.string(),
  type: OperatorTypeEnumZ,
});

const UserResponsibleAccessDetailsSchema = z.object({
  usercode: z.number(),
  departmentId: z.number(),
  employeeTypeId: z.number(),
});

const OperatorSuffixSchema = z.enum(['CX', 'GE']);

const BlockReasonSchema = z.enum([
  'incompatible_with_role',
  'extra_for_role',
  'legacy_block_all_active',
]);

const UserKeepItemSchema = z.object({
  w07usucod: z.string(),
  suffix: OperatorSuffixSchema,
});

const UserBlockItemSchema = z.object({
  w07usucod: z.string(),
  suffix: OperatorSuffixSchema,
  reason: BlockReasonSchema,
});

const OperatorKeepItemSchema = z.object({
  rspcod: z.number(),
  departmentId: z.number(),
  employeeTypeId: z.number(),
  pair: z.string(),
});

const OperatorBlockItemSchema = z.object({
  rspcod: z.number(),
  departmentId: z.number(),
  employeeTypeId: z.number(),
  pair: z.string(),
  reason: BlockReasonSchema,
});

export const AccessPlanSchema = z
  .object({
    targetCargo: UserResponsibleTypeEnumZ,
    source: z.enum(['term_flow', 'retaguarda_legacy']),
    users: z
      .object({
        toCreate: z.array(
          z
            .object({
              suffix: OperatorSuffixSchema,
              permissionCodes: z.array(z.string()).optional(),
            })
            .passthrough()
        ),
        toKeep: z.array(UserKeepItemSchema.passthrough()),
        toBlock: z.array(UserBlockItemSchema.passthrough()),
      })
      .passthrough(),
    operators: z
      .object({
        toCreate: z.array(
          z
            .object({
              departmentId: z.number(),
              employeeTypeId: z.number(),
            })
            .passthrough()
        ),
        toKeep: z.array(OperatorKeepItemSchema.passthrough()),
        toBlock: z.array(OperatorBlockItemSchema.passthrough()),
      })
      .passthrough(),
  })
  .passthrough();

export const InventorySnapshotSchema = z
  .object({
    fetchedAt: z.string(),
    usersFound: z.number(),
    operatorsFound: z.number(),
  })
  .passthrough();

export const CreateAccessResponseSchema = z
  .object({
    accessType: UserResponsibleTypeEnumZ,
    operators: z.object({
      password: z.string(),
      accessesCreated: z.array(OperatorAccessDetailsSchema),
    }),
    userResponsible: z.object({
      password: z.string(),
      accessesCreated: z.array(UserResponsibleAccessDetailsSchema),
    }),
    // R-F2: plan e inventorySnapshot são z.unknown() aqui para que o parse
    // principal não falhe se o backend retornar shape malformado. O componente
    // faz parse SEPARADO via AccessPlanSchema/InventorySnapshotSchema e mostra
    // mensagem amigável se o parse específico falhar.
    plan: z.unknown().optional(),
    inventorySnapshot: z.unknown().optional(),
  })
  .passthrough();
